import './App.css';
import Calculator from './components/Calculator';
import SocialMedia from './components/SocialMedia'
/*import Calculator from './components/Calculator';*/



function App() {
  return (
    <div className="App">
      <Calculator/>
      <SocialMedia/>
     
    </div>
  );
}

export default App;
